// Registers a tool renderer for every `Agent:<display name>` tool call in the
// current thread.
//
// The point is `display: 'standalone'`: assistant-ui's part grouping treats a
// standalone tool call as its own block instead of folding it into the
// orchestrator's collapsed "Used N tools" chain-of-thought group (which also
// needs the `'standalone-tool-call'` key in the groupBy map — see
// ChatMessage). A delegated specialist is a conversation, not a trace line, so
// it must not render with the same weight as one `python_exec` call. Same
// mechanism as `UpdateArtifactToolUI`.
//
// Names come from the transcript rather than the agent catalog because the
// catalog needs an `AgentsApiProvider` the chat route does not mount, and
// because a name read from the thread cannot drift from the one the backend
// emitted. A card appearing for the first time renders grouped for the frame
// before its renderer registers; it is empty at that point.
import { useAssistantToolUI, useAuiState } from '@assistant-ui/react';
import { SpecialistCard } from '@/entities/message';

function RegisterSpecialistCard({ toolName }: { toolName: string }) {
  useAssistantToolUI({ toolName, render: SpecialistCard, display: 'standalone' });
  return null;
}

export function SpecialistToolUIs() {
  const messages = useAuiState((state) => state.thread.messages);
  const toolNames = new Set<string>();
  for (const message of messages) {
    for (const part of message.content) {
      if (part.type === 'tool-call' && part.toolName.startsWith('Agent:')) toolNames.add(part.toolName);
    }
  }
  return (
    <>
      {[...toolNames].map((toolName) => (
        <RegisterSpecialistCard key={toolName} toolName={toolName} />
      ))}
    </>
  );
}
